import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import { StockTransferRo, vRdxUserInfo } from "../../../Redux/roStore";
import CloseIcon from "@mui/icons-material/Close";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { CmpCheckboxField } from "../../../Component/Common/ToolBox/ToolBox";
import {
  ConfirmAndSaveINV10BDetails_FromReq,
  INV10Request_LoadDetail,
  SaveINV10BDetails_FromReq,
  ValidateINV10BDetails_FromReq,
} from "../../../Server/ApiV2";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
const LoadFromRequest = ({
  xOpen = false,
  fCloseLoadRequestModal,
  vRdxWmsHead,
  xTitle = "Load From Request",
  fNewDetail = () => {},
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const vMediaQuery = useMediaQuery("(max-width: 1024px)");

  const [row, setRow] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [isEditing, setIsEditing] = useState(false);

  const [deleteAdd, setDeleteAdd] = useState(false);

  const fetchLoadFromRequest = async () => {
    var obj = {
      v_VocTyp: vRdxWmsHead?.A_RefDocCd,
      v_VocNo: vRdxWmsHead?.A_RefDocType,
      v_Loc: vRdxWmsHead?.A_FromLoc,
      v_LocTo: vRdxWmsHead?.A_ToLoc,
      v_AddOH: "Y",
    };

    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const Res = await INV10Request_LoadDetail(FinalObj);

    if (Res?.status === 200) {
      setRow(Res?.data?.ResultSet);
      fAlertToast("Success", "Successfully Loaded");
    }
  };
  console.log("row  : ", row);
  useEffect(() => {
    setRow([]);
    setSelectedRows([]);
    setDeleteAdd(false);
    if (xOpen) {
      fetchLoadFromRequest();
    }
  }, [xOpen]);

  //   const handleLoadBtn = async (date1=masterData?.fromDate , date2=masterData?.toDate , location=masterData?.location,verify=masterData?.verify,formattedDept=masterData?.department) => {

  //     var obj = {
  //       "Location":location.join(","),
  //       "VerifiedFlag":verify,
  //       "Date1": moment(date1).format("MM/DD/YYYY"),
  //       "Date2": moment(date2).format("MM/DD/YYYY"),
  //       "Department":formattedDept.join(",")
  //     }

  //     let FinalObj = fcheck_null_undefine_replace_empty(obj);
  //     const StockResponse = await ItemsSetupAudit001_GetRow(FinalObj);
  //       if (StockResponse?.status === 200) {
  //         setRow(StockResponse?.data?.recordset);
  //       }
  //   };

  const fLoad = async () => {
    const items = selectedRows?.map((item) => ({
      B_Itmcd: item.B_Itmcd,
      ItemName: item.ItemName,
      B_Qty: item.B_Qty,
      EditQty: item.EditQty,
      B_Unit: item.B_Unit,
      TaxDept: item.TaxDept,
      TaxPerc: item.TaxPerc,
      UCost: item.UCost,
      OHUnit: item.OHUnit,
      OHPcs: item.OHPcs,
      SavedQty: item.SavedQty,
    }));
    var obj = {
      vocTyp: vRdxWmsHead?.A_VocTyp,
      vocNo: vRdxWmsHead?.A_VocNo,

      postingDate: moment(vRdxWmsHead?.A_PostDt).format("MM/DD/YYYY"),
      loc: vRdxWmsHead?.A_FromLoc,
      locTo: vRdxWmsHead?.A_ToLoc,
      items: items,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const FromReqRes = await ValidateINV10BDetails_FromReq(FinalObj);
    if (FromReqRes?.status === 200) {
      let msg = FromReqRes?.data?.ResultSet[0]?.Message;
      confirmAlert({
        title: "Save",
        message: msg,
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              handleSaveBtn(msg);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  const handleSaveBtn = async (msg) => {
    // ID, ItmCd, Location, FieldName, ApprovedValue

    if (selectedRows.length == 0) {
      fAlertToast("FAILED", "LineItems should not be empty");
      return;
    }

    const invalidItem = selectedRows.find(
      (item) => item.EditQty == 0 || item.EditQty == ""
    );

    if (invalidItem) {
      fAlertToast("FAILED", "EditQty should not be empty or zero");
      return;
    }

    const items = selectedRows?.map((item) => ({
      B_Itmcd: item.B_Itmcd,
      ItemName: item.ItemName,
      B_Qty: item.B_Qty,
      EditQty: item.EditQty,
      B_Unit: item.B_Unit,
      TaxDept: item.TaxDept,
      TaxPerc: item.TaxPerc,
      UCost: item.UCost,
      OHUnit: item.OHUnit,
      OHPcs: item.OHPcs,
      SavedQty: item.SavedQty,
    }));
    var obj = {
      vocTyp: vRdxWmsHead?.A_VocTyp,
      vocNo: vRdxWmsHead?.A_VocNo,
      refDocTyp: vRdxWmsHead?.A_RefDocCd,
      refDocNo: vRdxWmsHead?.A_RefDocType,
      deleteBeforeInsert: deleteAdd,
      ErrorMsg: msg,
      items: items,
    };
    console.log("obj : ", obj);
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const FromReqRes = await ConfirmAndSaveINV10BDetails_FromReq(FinalObj);
    if (FromReqRes?.status === 200) {
      fAlertToast("SUCCESS", "Saved Successfully");
      const { HeadObject } = StockTransferRo();
      fNewDetail(HeadObject.A_VocNo, HeadObject.A_VocTyp);
      setRow([]);
      setSelectedRows([]);
      fCloseLoadRequestModal();
    }
  };

  const fEditQty = (params, value) => {
    const currentRowIndex = row.findIndex(
      (row) => row.B_Srno === params.row.B_Srno
    );
    const currentRow = row[currentRowIndex];

    const newRow = {
      ...currentRow,
      EditQty: value,
    };

    const newRowData = [...row];
    newRowData[currentRowIndex] = newRow;

    setRow(newRowData);

    params.row.EditQty = value;
    let updatedSelectedRows = [...selectedRows];

    const rowExists = updatedSelectedRows.some(
      (row) => row.B_Srno === params.row.B_Srno
    );
    if (!rowExists) {
      updatedSelectedRows.push({
        B_Srno: params.row.B_Srno,
        B_Itmcd: params.row.B_Itmcd,
        ItemName: params.row.ItemName,
        B_Qty: params.row.B_Qty,
        EditQty: params.row.EditQty,
        B_Unit: params.row.B_Unit,
        TaxDept: params.row.TaxDept,
        TaxPerc: params.row.TaxPerc,
        UCost: params.row.UCost,
        OHUnit: params.row.OHUnit,
        OHPcs: params.row.OHPcs,
        SavedQty: params.row.SavedQty,
      });
    } else {
      updatedSelectedRows = updatedSelectedRows.map((row) =>
        row.B_Srno === params.row.B_Srno
          ? { ...row, EditQty: Number(value) }
          : row
      );
    }

    setSelectedRows(updatedSelectedRows);

    return params.row;
  };

  const handleSelectionChange = (selectedIds) => {
    if (!row || row.length === 0) return;

    let updatedDetails = [...row];
    let updatedSelectedRows = [];

    updatedDetails = updatedDetails.map((row) => {
      if (selectedIds.includes(row.B_Srno)) {
        updatedSelectedRows.push({
          B_Srno: row.B_Srno,
          B_Itmcd: row.B_Itmcd,
          ItemName: row.ItemName,
          B_Qty: row.B_Qty,
          EditQty: row.EditQty,
          B_Unit: row.B_Unit,
          TaxDept: row.TaxDept,
          TaxPerc: row.TaxPerc,
          UCost: row.UCost,
          OHUnit: row.OHUnit,
          OHPcs: row.OHPcs,
          SavedQty: row.SavedQty,
        });
        return { ...row, EditQty: row.EditQty };
      } else {
        return { ...row, EditQty: row.EditQty };
      }
    });

    setRow(updatedDetails);
    setSelectedRows(updatedSelectedRows);
    console.log(selectedRows);
  };

  return (
    <Modal
      open={xOpen}
      onClose={fCloseLoadRequestModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
      gnr-item-search 
      model-gc-search
      "
      >
        <GCTitleSticky title={xTitle} onClose={fCloseLoadRequestModal} />

        <div className="p-2">
          <Grid
            container
            rowSpacing={2}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            sx={{ padding: 2 }}
          >
            <Grid item xs={7.5} sm={8} md={4} lg={4}>
              <Typography>Transfer Type</Typography>
              <CmpTextFieldV1
                xLabelText=""
                xValue={vRdxWmsHead?.A_VocTypName}
                xType={"text"} // text/number/password
                xName={"tType"}
                xReadOnly={true}
              />
            </Grid>
            <Grid item xs={4.5} sm={4} md={2} lg={2}>
              <Typography>Transfer No</Typography>
              <CmpTextFieldV1
                xLabelText=""
                xValue={vRdxWmsHead?.A_VocNo}
                xType={"text"} // text/number/password
                xName={"tNo"}
                xReadOnly={true}
              />
            </Grid>
            <Grid item xs={7.5} sm={8} md={4} lg={4}>
              <Typography>Ref Doc Type</Typography>
              <CmpTextFieldV1
                xLabelText=""
                xValue={vRdxWmsHead?.A_RefDocName}
                xType={"text"} // text/number/password
                xName={"rType"}
                xReadOnly={true}
              />
            </Grid>
            <Grid item xs={4.5} sm={4} md={2} lg={2}>
              <Typography>Ref Doc No</Typography>
              <CmpTextFieldV1
                xLabelText=""
                xValue={vRdxWmsHead?.A_RefDocType}
                xType={"text"} // text/number/password
                xName={"rNo"}
                xReadOnly={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Typography>From Location</Typography>
              <CmpTextFieldV1
                xLabelText=""
                xValue={vRdxWmsHead?.A_FromLocName}
                xType={"text"} // text/number/password
                xName={"A_VocTyp"}
                xReadOnly={true}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <Typography>To Location</Typography>
              <CmpTextFieldV1
                xLabelText=""
                xValue={vRdxWmsHead?.A_ToLocName}
                xType={"text"} // text/number/password
                xName={"A_VocTyp"}
                xReadOnly={true}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={4}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                textAlign: "right",
              }}
            >
              <Grid container>
                <Grid
                  item
                  xs={8}
                  sm={9}
                  md={9}
                  lg={8}
                  sx={{
                    mt: 3,
                    display: "flex",
                    justifyContent: "flex-end",
                    textAlign: "right",
                  }}
                >
                  <CmpCheckboxField
                    xChecked={deleteAdd === true}
                    xOnChange={(e) => {
                      setDeleteAdd(e.target.checked);
                    }}
                    xName={"Delete and Add"}
                    xNameField={"Delete and Add"}
                  />
                </Grid>
                <Grid item xs={4} sm={3} md={3} lg={4}>
                  <Button
                    variant="contained"
                    sx={{
                      width: isMobile ? "75px" : "100px",
                      height: "35px",
                      mt: 2,
                      textTransform: "capitalize",
                    }}
                    disabled={isEditing}
                    onClick={(e) => {
                      fLoad();
                    }}
                  >
                    Load
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <div style={{ height: "53vh", width: "100%", marginTop: "1.5%" }}>
                <DataGrid
                  rows={row}
                  columns={[
                    { field: "B_Srno", headerName: "SrNo", width: 50 },
                    {
                      field: "B_Itmcd",
                      headerName: "Item Code",
                      width: 100,
                    },
                    {
                      field: "ItemName",
                      headerName: "Item Name",
                      width: vMediaQuery ? 250 : 0,
                      flex: vMediaQuery ? 0 : 1,
                    },
                    {
                      field: "B_Qty",
                      headerName: "Req Qty",
                      width: 75,
                    },
                    { field: "B_Unit", headerName: "Unit", width: 75 },
                    { field: "SavedQty", headerName: "Saved Qty", width: 75 },
                    {
                      field: "TaxDept",
                      headerName: "TaxDept",
                      width: 150,
                      hide: true,
                    },
                    {
                      field: "TaxPerc",
                      headerName: "TaxPerc",
                      width: 150,
                      hide: true,
                    },
                    {
                      field: "UCost",
                      headerName: "UCost",
                      width: 150,
                      hide: true,
                    },
                    {
                      field: "OHUnit",
                      headerName: "OHUnit",
                      width: 150,
                      hide: true,
                    },
                    {
                      field: "OHPcs",
                      headerName: "OHPcs",
                      width: 150,
                      hide: true,
                    },
                    {
                      field: "EditQty",
                      headerName: "EditQty",
                      width: 75,
                      type: "number",
                      renderCell: (params) => (
                        <TextField
                          type="number"
                          value={params.value}
                          onChange={(e) => fEditQty(params, e.target.value)}
                          onBlur={() => setIsEditing(false)}
                          onFocus={() => setIsEditing(true)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              const currentRowIndex = row.findIndex(
                                (row) => row.B_Srno === params.row.B_Srno
                              );
                              const nextRow = row[currentRowIndex + 1];

                              if (nextRow) {
                                const nextInput = document.querySelector(
                                  `input[name="EditQty-${nextRow.B_Srno}"]`
                                );
                                if (nextInput) {
                                  nextInput.focus();
                                }
                              }
                            }
                          }}
                          inputProps={{ name: `EditQty-${params.row.B_Srno}` }} // Unique input name for easy selection
                        />
                      ),
                    },
                  ]}
                  checkboxSelection
                  getRowId={(row) => row.B_Srno}
                  rowHeight={isMobile ? 30 : 40}
                  headerHeight={40}
                  onSelectionModelChange={(selectedIds) =>
                    handleSelectionChange(selectedIds)
                  }
                  selectionModel={selectedRows.map((row) => row.B_Srno)}
                  hideFooter={row.length < 100}
                  disableSelectionOnClick
                  onCellEditStart={() => setIsEditing(true)}
                  onCellEditStop={() => {
                    setIsEditing(false);
                  }}
                  onCellEditCommit={() => setIsEditing(false)}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </Box>
    </Modal>
  );
};

export default LoadFromRequest;
